import { useMemo } from 'react'
import useNotificationStore from '../../services/notificationStore'

export default function NotificationLiveRegion() {
  const toasts = useNotificationStore((state) => state.toasts)

  const latestAnnouncement = useMemo(() => {
    const candidates = (toasts || []).filter((toast) => toast.kind !== 'operation-progress')
    if (!candidates.length) return null
    return candidates[0]
  }, [toasts])

  const politeness = latestAnnouncement?.severity === 'error' ? 'assertive' : 'polite'
  const message = latestAnnouncement ? `${latestAnnouncement.title}. ${latestAnnouncement.message}`.trim() : ''

  return (
    <div aria-live={politeness} aria-atomic="true" className="sr-only">
      {message}
    </div>
  )
}
